var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107.28 107.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff6b00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-person",
    className: "cls-1",
    d: "M53.64,0c-14.75,0-26.82,15.02-26.82,33.53s12.07,33.53,26.82,33.53,26.82-15.02,26.82-33.53S68.39,0,53.64,0ZM25.61,67.05C11.28,67.71,0,79.52,0,93.87v13.41H107.28v-13.41c.05-14.37-11.26-26.21-25.61-26.82-7.24,8.18-17.16,13.41-28.03,13.41s-20.79-5.23-28.03-13.41Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilOrange);
export default __webpack_public_path__ + "static/media/Profil_orange.07bd15818820be3ed6e761e2910797d3.svg";
export { ForwardRef as ReactComponent };